<template>
  <section class="section" :class="rootClasses" :style="{ zIndex: slantedBottom ? 2 : 1 }">
    <div
      v-if="slanted"
      class="slanted"
      :class="slantedBottom ? 'slanted--bottom' : 'slanted--top'"
      :style="{ transform: 'skewY(' + slanted + 'deg)' }"
    ></div>
    <div class="content" :style="{ height: height + 'px' }">
      <SectionTitle v-if="title && title.length" :white="isWhiteColor">
        {{ title }}
      </SectionTitle>
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'Section',

  props: {
    viewportHeight: Boolean,
    title: String,
    padH: Boolean,
    padT: Boolean,
    height: Number,
    slantedBottom: Boolean,
    slanted: { type: Number, default: null },
    lastSection: Boolean,
    background: {
      type: String,
      default: 'fill-1',
      validator: (value) => {
        return ['fill-1', 'fill-2', 'fill-3', 'fill-4'].includes(value);
      },
    },
  },

  computed: {
    rootClasses: function () {
      return {
        'section--fill-1': this.background === 'fill-1',
        'section--fill-2': this.background === 'fill-2',
        'section--fill-3': this.background === 'fill-3',
        'section--fill-4': this.background === 'fill-4',
        'section--pad-h': this.padH,
        'section--pad-t': this.padT,
        'section--viewport-height': this.viewportHeight,
        'section--last': this.lastSection,
      };
    },
    isWhiteColor: function () {
      return this.background === 'fill3' || this.background === 'fill4';
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  position: relative;

  &--last {
    padding-bottom: 200px;
  }
  &--viewport-height {
    height: 100vh;
  }

  &--primary {
    background-color: $--color--primary;
  }
  &--secondary {
    background-color: $--color--secondary;
  }
  &--accent {
    background-color: $--color--accent;
  }

  &--fill-1 {
    background-color: $--color--fill-1;
  }
  &--fill-2 {
    background-color: $--color--fill-2;
  }
  &--fill-3 {
    background-color: $--color--fill-3;
  }
  &--fill-4 {
    background-color: $--color--fill-4;
  }

  &--pad-t {
    padding-top: 140px;
  }
  &--pad-h .content {
    padding-left: 8%;
    padding-right: 8%;

    @include respond-to('medium') {
      padding-left: 15%;
      padding-right: 15%;
    }

    @include respond-to('large') {
      padding-left: 20%;
      padding-right: 20%;
    }
  }
}

.content {
  height: 100%;
}

.slanted {
  background: inherit;
  content: '';
  display: block;
  height: 50%;
  left: 0;
  position: absolute;
  right: 0;
  z-index: -1;
  -webkit-backface-visibility: hidden; /* for Chrome Windows */

  &--top {
    top: 0;
    transform-origin: 100% 0;
  }

  &--bottom {
    bottom: 0;
    transform-origin: 100%;
  }
}
</style>
